import React, { Component } from "react";
import { ThemeToggler } from "gatsby-plugin-dark-mode";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { Link } from "gatsby";

import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Nav
} from "reactstrap";

class DesktopNavbar extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
      dropdownOpen: false
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  dropToggle = () => {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  };

  onMouseEnter = () => {
    this.setState({ dropdownOpen: true });
  };

  onMouseLeave = () => {
    this.setState({ dropdownOpen: false });
  };

  isActive = ({ isCurrent }) => {
    return isCurrent ? { className: "active-link nav-link" } : null;
  };

  render() {
    return (
      <header
        style={{
          background: "var(--navbg)",
          transition: "color 0.2s ease-out, background 0.2s ease-out"
        }}
      >
        <div className="container p-0 pl-2 pr-2">
          <Navbar className="navbar-expand-lg desktop-navbar">
            <NavbarBrand className="logo d-flex justify-content-start" href="/">
              <img
                src={require("../../../assets/tau-chain-logo.svg")}
                alt="Logo"
                className="logo img-fluid"
              />
              <h2
                className="companyName mb-0"
                style={{ color: "var(--h2Color)" }}
              >
                Tau.Support
              </h2>
            </NavbarBrand>
            <NavbarToggler onClick={this.toggle} className="text-light" />

            <Collapse
              isOpen={this.state.isOpen}
              id="navbarSupportedContent"
              navbar
            >
              <Nav className="mx-5 my-3 justify-content-between" navbar>
                <li className="nav-item active">
                  <Link
                    getProps={this.isActive}
                    className="nav-link"
                    to="/market"
                    style={{
                      color: "var(--navLinkColor)",
                      transition:
                        "color 0.2s ease-out, background 0.2s ease-out"
                    }}
                  >
                    Market <span className="sr-only">(current)</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    getProps={this.isActive}
                    className="nav-link"
                    to="/social"
                    style={{
                      color: "var(--navLinkColor)",
                      transition:
                        "color 0.2s ease-out, background 0.2s ease-out"
                    }}
                  >
                    Social
                  </Link>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="#"
                    style={{
                      color: "var(--navLinkColor)",
                      transition:
                        "color 0.2s ease-out, background 0.2s ease-out"
                    }}
                  >
                    News
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="#"
                    style={{
                      color: "var(--navLinkColor)",
                      transition:
                        "color 0.2s ease-out, background 0.2s ease-out"
                    }}
                  >
                    <span className="tau-documents-sm">Tau</span>
                    <span className="tau-documents">Tau Documents</span>
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="#"
                    style={{
                      color: "var(--navLinkColor)",
                      transition:
                        "color 0.2s ease-out, background 0.2s ease-out"
                    }}
                  >
                    Dev Tools
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="#"
                    style={{
                      color: "var(--navLinkColor)",
                      transition:
                        "color 0.2s ease-out, background 0.2s ease-out"
                    }}
                  >
                    Apps
                  </a>
                </li>
              </Nav>
            </Collapse>
            <div className="d-flex justify-content-between">
              <div
                className="form-group has-search my-2 mr-1 search-field header-search"
                style={{
                  borderRadius: "var(--searchBorderRadius)",
                  transition: "color 0.2s ease-out, background 0.2s ease-out"
                }}
              >
                <FontAwesomeIcon
                  icon={faSearch}
                  className="form-control-feedback ml-1 pt-2"
                  style={{ color: "var( --searchText)" }}
                />
                <input
                  type="text"
                  className="form-control border-0"
                  placeholder="Search"
                  style={{
                    background: "var(--searchBg)",
                    color: "var(--pColor)"
                  }}
                />
              </div>
              <ThemeToggler>
                {({ theme, toggleTheme }) => {
                  return (
                    <div className="switch-mode pt-2">
                      <span
                        className="current-mode ml-2"
                        style={{
                          color: "var(--darkmode)",
                          transition:
                            "color 0.2s ease-out, background 0.2s ease-out"
                        }}
                      >
                        {" "}
                        Dark Mode{" "}
                      </span>
                      <label className="switch mt-1">
                        <input
                          type="checkbox"
                          onChange={e => {
                            return toggleTheme(
                              e.target.checked ? "light" : "dark"
                            );
                          }}
                          checked={theme === "light"}
                        />
                        <span className="slider round"></span>
                      </label>
                      <span
                        className="current-mode ml-2"
                        style={{
                          color: "var(--lightmode)",
                          transition:
                            "color 0.2s ease-out, background 0.2s ease-out"
                        }}
                      >
                        Light Mode{" "}
                      </span>
                    </div>
                  );
                }}
              </ThemeToggler>
              <UncontrolledDropdown
                className="d-inline-block lang-drop"
                onMouseOver={this.onMouseEnter}
                onMouseLeave={this.onMouseLeave}
                isOpen={this.state.dropdownOpen}
                toggle={this.dropToggle}
              >
                <DropdownToggle className="lang-flag-drop">
                  <img
                    src={require("../../../assets/flags/us-flag.svg")}
                    className="img-fluid"
                  />
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem>
                    <img
                      src={require("../../../assets/flags/us-flag.svg")}
                      className="img-fluid"
                    />
                  </DropdownItem>
                  <DropdownItem>
                    <img
                      src={require("../../../assets/flags/china-flag.svg")}
                      className="img-fluid"
                    />
                  </DropdownItem>
                  <DropdownItem>
                    <img
                      src={require("../../../assets/flags/es-flag.svg")}
                      className="img-fluid"
                    />
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          </Navbar>
        </div>
      </header>
    );
  }
}

export default DesktopNavbar;
